import router, { constantRoutes, dynamicRoutes } from "@/router";
import Layout from "@/layout/index";
import ParentView from "@/components/ParentView";
import InnerLink from "@/layout/components/InnerLink";

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: [
      // {
      //   path: '',
      //   children: [
      //     {
      //       path: 'index',
      //       meta: { title: '首页', icon: 'dashboard', affix: true }
      //     }
      //   ]
      // },
      // {
      //   alwaysShow: true,
      //   path: "/setting",
      //   meta: { title: "管理配置", icon: "user" },
      //   children: [
      //     {
      //       path: "profile",
      //       meta: { title: "看板配置", icon: "user" },
      //     },
      //   ],
      // },
    ],
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes;
      state.routes = constantRoutes.concat(routes);
    },
    SET_DEFAULT_ROUTES: (state, routes) => {
      state.defaultRoutes = constantRoutes.concat(routes);
    },
    SET_TOPBAR_ROUTES: (state, routes) => {
      state.topbarRouters = routes;
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      // console.log(routes);
      state.sidebarRouters = routes;
    },
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }, menuInfo) {
      return new Promise((resolve) => {
        // 向后端请求路由数据
        // getRouters().then(res => {
        // const sdata = JSON.parse(JSON.stringify(res.data))
        // const rdata = JSON.parse(JSON.stringify(res.data))
        // const menuRoutes = filterAsyncRouter(menuInfo);
        // const rewriteRoutes = filterAsyncRouter(rdata, false, true)
        // const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
        // dynamicRoutes.push({ path: '*', redirect: '/404', hidden: true })
        // router.addRoutes(dynamicRoutes);
        // this.$store.commit('user/SET_PERMISSIONS',["111"]);
        const menuRoutes = [
          {
            "id": "208774380645253120",
            "code": "",
            "name": "学生管理与服务一体化平台",
            "path": "",
            "description": "学生管理与服务一体化平台",
            "children": [
              {
                "id": "210631910980845568",
                "code": "systemConfig",
                "name": "系统配置",
                "route": "/systemConfig",
                "description": "",
                "children": [
                  {
                    "id": "210631966452613120",
                    "code": "year",
                    "name": "学年",
                    "route": "/year",
                    "description": "",
                    "children": [],
                    "operation_list": [],
                  },
                  {
                    "id": "210631997629923328",
                    "code": "term",
                    "name": "学期",
                    "route": "/term",
                    "description": "",
                    "children": [],
                    "operation_list": [
                      {
                        "id": "210639024842342400",
                        "code": "add",
                        "name": "新增",
                        "description": ""
                      },
                      {
                        "id": "210639035414085632",
                        "code": "edit",
                        "name": "编辑",
                        "description": ""
                      },
                      {
                        "id": "210639046528991232",
                        "code": "delete",
                        "name": "删除",
                        "description": ""
                      }
                    ],
                  },
                  {
                    "id": "210737932199264256",
                    "code": "currentYearTerm",
                    "name": "当前学年学期",
                    "route": "/currentYearTerm",
                    "description": "",
                    "children": [],
                    "operation_list": [
                      {
                        "id": "210740714198269952",
                        "code": "edit",
                        "name": "编辑",
                        "description": ""
                      }
                    ],
                  }
                ],
                "operation_list": []
              },
              {
                "id": "210654523393310720",
                "code": "adminManage",
                "name": "教务管理员",
                "route": "/adminManage",
                "description": "",
                "menu_list": [],
                "operation_list": [
                  {
                    "id": "210654609342988288",
                    "code": "add",
                    "name": "新增",
                    "description": ""
                  },
                  {
                    "id": "210654630978256896",
                    "code": "edit",
                    "name": "编辑",
                    "description": ""
                  },
                  {
                    "id": "210654642176000000",
                    "code": "delete",
                    "name": "删除",
                    "description": ""
                  },
                  {
                    "id": "210660310175973376",
                    "code": "changeStatus",
                    "name": "启用/停用",
                    "description": ""
                  },
                  {
                    "id": "210660357622988800",
                    "code": "resetPassword",
                    "name": "重置密码",
                    "description": ""
                  }
                ],
              },
            ]
          }
        ];
        const reportRoutes = [

        ];
        commit('SET_ROUTES', reportRoutes.concat(menuInfo.menu_list))
        commit("SET_SIDEBAR_ROUTERS", reportRoutes.concat(menuInfo.menu_list));
        commit("SET_DEFAULT_ROUTES", reportRoutes.concat(menuInfo.menu_list));
        commit("SET_TOPBAR_ROUTES", reportRoutes.concat(menuInfo.menu_list));
        // commit("SET_PERMISSIONS", ["demo:add"]);
        resolve(reportRoutes.concat(menuInfo.menu_list));
        // })
      });
    },
  },
};

function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.map((item) => {
    if (item.children != null && item.children && item.children.length) {
      item.alwaysShow = true;
      filterAsyncRouter(item.children);
    } else {
      delete item["children"];
      delete item["redirect"];
    }
    item.redirect = "noredirect";
    item.path = item.url.replace(process.env.VUE_APP_BASE_URL, "");
    item.meta = { title: item.name, icon: "" };
    return item;
  });
}

// 遍历后台传来的路由字符串，转换为组件对象
// function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
//   return asyncRouterMap.filter(route => {
//     if (type && route.children) {
//       route.children = filterChildren(route.children)
//     }
//     if (route.component) {
//       // Layout ParentView 组件特殊处理
//       if (route.component === 'Layout') {
//         route.component = Layout
//       } else if (route.component === 'ParentView') {
//         route.component = ParentView
//       } else if (route.component === 'InnerLink') {
//         route.component = InnerLink
//       } else {
//         route.component = loadView(route.component)
//       }
//     }
//     if (route.children != null && route.children && route.children.length) {
//       route.children = filterAsyncRouter(route.children, route, type)
//     } else {
//       delete route['children']
//       delete route['redirect']
//     }
//     return true
//   })
// }

// function filterChildren(childrenMap, lastRouter = false) {
//   var children = []
//   childrenMap.forEach((el, index) => {
//     if (el.children && el.children.length) {
//       if (el.component === 'ParentView' && !lastRouter) {
//         el.children.forEach(c => {
//           c.path = el.path + '/' + c.path
//           if (c.children && c.children.length) {
//             children = children.concat(filterChildren(c.children, c))
//             return
//           }
//           children.push(c)
//         })
//         return
//       }
//     }
//     if (lastRouter) {
//       el.path = lastRouter.path + '/' + el.path
//       if (el.children && el.children.length) {
//         children = children.concat(filterChildren(el.children, el))
//         return
//       }
//     }
//     children = children.concat(el)
//   })
//   return children
// }

// // 动态路由遍历，验证是否具备权限
// export function filterDynamicRoutes(routes) {
//   const res = []
//   routes.forEach(route => {
//     if (route.permissions) {
//       if (auth.hasPermiOr(route.permissions)) {
//         res.push(route)
//       }
//     } else if (route.roles) {
//       if (auth.hasRoleOr(route.roles)) {
//         res.push(route)
//       }
//     }
//   })
//   return res
// }

// export const loadView = (view) => {
//   if (process.env.NODE_ENV === 'development') {
//     return (resolve) => require([`@/views/${view}`], resolve)
//   } else {
//     // 使用 import 实现生产环境的路由懒加载
//     return () => import(`@/views/${view}`)
//   }
// }

export default permission;
